document.addEventListener('DOMContentLoaded', function () {
    
    let selectList = [];//选择列表
    let renderProductList = [];//渲染的列表(扁平化数组)
    let newRenderProductList = [];//去重数组
    let tag_list_get = [];//tag_list原数据
    let newFilterList = [];//filter列表
    let totalNum = 0;//选择的总数
    let variant_id_list = [];// variant_id列表
    let hasMoved = false; // 是否已经移动过
    let product_lists = [];// 产品列表id集合
    let all_product_list = [];// 所有产品列表id集合
    let product_list_get = [];//针对产品详情
    let scenePage = 1;//场景页码
    let sceneNum =15;//场景每页数量
    let search_tag='';//多个tag用逗号分隔
    let newDataScene = [];//场景数据分页
    let targetId = [];//点击tag的id,最后split成字符串传参
    let changePageNum = 0;//默认第一页
    let isScene = window.location.pathname.includes('/find-my-outfit')//判断是否是场景页
    let isLoading = false;
    let hasMore = true;
    let sceneDetailObj = {};//场景详情(针对url有sceneId,但是不在第一页的产品)
    let clickIndexList = [];

    // graphQL 请求参数
    const query = `
      query getProducts(
        $ids: [ID!]!,
        $country: CountryCode
      ) @inContext(country: $country) {

        nodes(ids: $ids) {
          ... on Product {
            id
            title
            handle

            # ✅ 产品层价格（你要的）
            priceRange {
              minVariantPrice {
                amount
                currencyCode
              }
              maxVariantPrice {
                amount
                currencyCode
              }
            }

            featuredImage {
              url
            }

            variants(first: 100) {
              nodes {
                id
                title
                availableForSale
                quantityAvailable

                # SKU 价格（可选，切变体时用）
                price {
                  amount
                }
              }
            }
          }
        }
      }
    `;


    // 左侧分类
    if(isScene){
      leftTags();
    }
    
    function leftTags() { 
      fetchRequest(`${heychic_api}/web/active/outfit/tagList`, "GET")
      .then((result) => {
         if (result.code == 200) { 
          const data = result.data;
          tag_list_get = data;
          renderCategoryList(tag_list_get);
         }
      })
      .catch((error) => {
          console.error("GET Error:", error);
      }); 
    }

    // 渲染分类列表
    function renderCategoryList(tag_list) { 
      

     $('.category-text').empty();
      tag_list.forEach((item,index) => {
        // 判断当前项是否展开
        const isOpen = clickIndexList.includes(index); // 这是你之前定义的展开状态数组
        
        // 根据展开状态选择图片
        const iconSrc = !isOpen 
          ? 'https://cdn.heychic.net/material/productInfo/faqmin-e48c22ef508d4af.png'   // 展开时的减号图标
          : 'https://cdn.heychic.net/material/productInfo/faqadd-8ee43f2c36f7b12.png'; // 收起时的加号图标

        $('.category-text').append(`
          <div class="category-item">
            <div class="tag-title" data-index="${index}">${item.tag} <img src="${iconSrc}" alt="add-icon" class="add-icon" /></div>
            <div class="tag-hide ${isOpen ? 'is-hidden' : ''}">
              ${
                item.tag_list.map((r,y) => {
                  const isSelected = targetId.includes(String(r.id)); // 检查当前项是否在targetId数组中
                  return `<div data-index="${y}" data-id="${r.id}" class="category-name-list ${isSelected ? 'is-select' : ''}" onclick="selectCategory(this,event,${index})">
                    <span class="category-quare"><img src="https://cdn.heychic.net/material/review/categorytrue-ebcb3b10712ef43.png" class="check-icon ${isSelected ? 'check-icon-active' : ''}" alt="check-icon" /></span>
                    ${r.tag}
                  </div>`
                }).join('')
              }</div>
          </div>
        `)
      })
    }

    // 使用原生 JS 事件委托
    document.addEventListener('click', function(e) {
      // ✅ 必须加判断：确保点击的是 .tag-title 或其子元素才执行
      if (e.target.closest('.tag-title')) {
        const title = e.target.closest('.tag-title');
        const index = title.getAttribute('data-index'); // 获取 data-index 属性的值
        // clickIndexList.push(Number(index))
        // clickIndexList = [...new Set(clickIndexList)];  
        $(title).siblings('.tag-hide').toggleClass('is-hidden');
        if($(title).children('.add-icon').attr('src') == 'https://cdn.heychic.net/material/productInfo/faqmin-e48c22ef508d4af.png'){
          $(title).children('.add-icon').attr('src','https://cdn.heychic.net/material/productInfo/faqadd-8ee43f2c36f7b12.png');
          // $(title).siblings('.tag-hide').addClass('is-hidden');
        }else{
          $(title).children('.add-icon').attr('src','https://cdn.heychic.net/material/productInfo/faqmin-e48c22ef508d4af.png');
          // $(title).siblings('.tag-hide').removeClass('is-hidden');
        }

        // if($(title).siblings('.tag-hide').hasClass('is-hidden')){
        //   clickIndexList = clickIndexList.filter(i => i !== Number(index));
        // }
      }
    });

    // 展开收起
    window.categoryClick = function(e) {
      if(window.innerWidth <= 1024){
        const $clickedItem = $(e);
      
        // 切换当前点击项的状态
        if ($clickedItem.hasClass('is-open')) {
            // 如果当前项是展开状态，则收起它
            hideBg();
            $clickedItem.removeClass('is-open');
            if(window.innerWidth <= 1024) {
              $('.scene-collocation .h5-bot-tri').removeClass('is-rotated'); // 添加旋转类名
            }
        } else {
            // 如果当前项是收起状态，则展开它
            $clickedItem.addClass('is-open');
            if(window.innerWidth <= 1024){
              $('.scene-collocation .hide-scene-list-bg').show();
            }else{
              $('.scene-collocation .hide-scene-list').show();
            }
            if(window.innerWidth <= 1024) {
              // $('.scene-collocation .category-list-wrap').show();
              $('.scene-collocation .h5-bot-tri').addClass('is-rotated'); // 添加旋转类名
            }
        }
      }
    }

    // 查看更多
    window.viewMoreClick = function(e,clickedItem) {
      e.stopPropagation();
      const $clickedItemMore = $(clickedItem);
      if ($clickedItemMore.hasClass('is-up')) {
        $clickedItemMore.removeClass('is-up');
        $clickedItemMore.find('.topTri').attr('src','https://cdn.heychic.net/material/review/botTri-d4c4e28fed9a8f4.png');

        $('.category-text .category-item').each(function(i) { 
          if(i > 2){
            $(this).find('.category-name-list').addClass('is-active');
          }
        });
      } else {
        $clickedItemMore.addClass('is-up');
        $clickedItemMore.find('.topTri').attr('src','https://cdn.heychic.net/material/review/topTri-a9ad455b30d8ee9.png');
        $('.category-item .category-name-list').removeClass('is-active');
      }
    }

    // 是否选中
    window.selectCategory = function(item,e,index) { 
      e.stopPropagation();
      const $selectItem = $(item);
      const id = String($selectItem.attr('data-id')); // 确保是字符串
      if (targetId.includes(id)) {
        // 取消选中
        targetId = targetId.filter(e => e !== id);
      } else {
        // 选中
        targetId.push(id);
      }

      // clickIndexList.push(index)
      // clickIndexList = [...new Set(clickIndexList)]; 

      changePageNum = 0;
      scenePage = 1;
      search_tag = targetId.join(',');

      renderCategoryList(tag_list_get)

      //  const $item = $(item).closest('.category-item');
      //  const $icon = $item.find('.add-icon');

      //  if($icon.attr('src') == 'https://cdn.heychic.net/material/productInfo/faqadd-8ee43f2c36f7b12.png'){
      //   $icon.attr('src', 'https://cdn.heychic.net/material/productInfo/faqmin-e48c22ef508d4af.png');
      //  }else{
      //   $icon.attr('src', 'https://cdn.heychic.net/material/productInfo/faqadd-8ee43f2c36f7b12.png');
      //  }

      getSceneDataPage(scenePage,sceneNum,search_tag);
    }

    function hideBg() {
      if(window.innerWidth <= 1024){
        $('.scene-collocation .hide-scene-list-bg').hide();
        $('.category-all .category-name').removeClass('is-open');
      }else{
        $('.scene-collocation .hide-scene-list').hide();
      }
    }

    // 折叠菜单
    function collapseMenu() { 
      $('.category-name-list').removeClass('is-select');
      $('.category-name-list').find('.category-quare').empty();
      $('.category-name').removeClass('is-open');
      if(window.innerWidth <= 1024) {
        $('.scene-collocation .hide-scene-list-bg').hide();
      }
      $('.scene-collocation .h5-bot-tri').removeClass('is-rotated'); // 移除旋转类名
    }
    // 清除筛选项
    window.clearInfo = function(e) {
      e.stopPropagation();
      collapseMenu();
      sceneNum=15;
      scenePage=1;
      search_tag = '';
      targetId = [];
      changePageNum = 0;
      clickIndexList = [];
      leftTags();
      getSceneDataPage(scenePage,sceneNum,search_tag);
    }

    document.addEventListener('click', function(e) { 
      if (e.target.closest('.modal-title .closeSign')) {
        hideBg();
      }
    });

    // 应用筛选
    window.applyInfo = function(e) { 
      e.stopPropagation();
      // rightCategoryProduct(totalNum == 0 ? tag_list_get : newFilterList);
      // $('.category-name').removeClass('is-open');
      hideBg();
    }

    // 分类列表产品
    function rightCategoryProduct(tag_list,isAppend = false) { 
      if (!isAppend) {
        renderProductList = [];
      }
       if (!isAppend) {
        $('.collocation-cont-right').empty();
      }
      if(window.location.pathname.includes('/products')){ 
        newRenderProductList = tag_list;
      }else{
        tag_list.forEach((r,t) => { 
          renderProductList.push(r);
        })
        newRenderProductList = renderProductList;
      }

      newRenderProductList = [...new Map(newRenderProductList.flat().map(d => [d.id, d])).values()]; //去重(id)
      $(".collocation-cont-left-title .total-nums").text(totalNum);//总数(组合)

      // 扁平化数组
      let productListScene = newRenderProductList.flatMap(item => {
        return item.material_config.show_data
          .slice(0, 3)
          .map((img, index) => ({
            ...img,
            id: item.id,
            type:item.type
          }));
      });

      // 组合成三个一组
      const groupedProduct = [];
      for (let i = 0; i < productListScene.length; i += 3) {
        groupedProduct.push(productListScene.slice(i, i + 3));
      }

      if(isScene){
        tag_list.forEach((item,index) => {
          const imgType = item.type;
          $('.collocation-cont-right').append(`
            <div class="collocation-cont-right-item">
              <div class="swiper collocation-swiper-pic">
                <div class="collocation-cont-right-item-wrapper swiper-wrapper">
                  ${
                    item.material_config.show_data.map((t,y) => {
                        return `
                        <div class="swiper-slide" onclick="collocationDetail(${item.id},${y})">
                          <img 
                          src="https://cdn.heychic.net/material/review/1-e4c21281e6e3796.jpg"
                          data-src="${imgType == 1 ? t.url : t.cover}"
                          alt="collocation-cont-right-item-img" 
                          class="collocation-cont-right-item-img swiper-lazy lazy-img" 
                          >
                          ${
                            window.innerWidth > 1024 ? `
                            <div class="scene-add">ADD TO BAG <img src="https://cdn.heychic.net/material/review/botAdd-c1bc152bfc0d92d.png" class="add-scene" alt="add-scene"/></div>
                            ` : ''
                          }
                        </div>
                          
                        `
                      }).join('')
                  }
                </div>
              </div>

              <div class="swiper collocation-swiper" style="display:none">
                  <div class="collocation-cont-right-item-bot swiper-wrapper">
                    ${
                      item.material_config.show_data.map((v,j) => {
                          return `
                            <img 
                            data-src="${imgType == 1 ? v.url : v.cover}"
                            alt="" 
                            class="collocation-cont-right-item-bot-img swiper-slide lazy-img">
                          `
                        }).join('')
                    }
                  </div>
              </div>
              ${
                window.location.pathname.includes('/find-my-outfit') ? `<div class="collocation-cont-bot-info" onclick="collocationDetail(${item.id})">
                  <div class="bot-info-text ${item.material_config.product_data.length <= 2 ? 'bot-info-text-two' : item.material_config.product_data.length > 2 ? 'bot-info-text-three' : 'bot-info-text-four'}">
                    ${
                      item.material_config.product_data.map((t,y) => {
                        // 根据产品id筛选出对应的产品价格
                        const filter_list = all_product_list.filter(item => item.id.includes(t.product_number));
                        const priceChange = filter_list[0]?.priceRange?.maxVariantPrice?.amount || '--'; // 获取价格
                        if(filter_list?.length > 0){
                          return `
                          <div class="info-text">
                            <div class="info-text-left">${t.product_title}</div>
                            <div class="info-text-right">
                              ${getCurrencySymbolAll(window.Shopify.currency.active)}${isInteger(priceChange)} ${window.Shopify.currency.active}
                            </div>
                          </div>
                          `
                        }
                      }).join('')
                    }
                  </div>  
                  <div class="bot-info-add">ADD TO BAG</div>
              </div>` : ``}
              
            </div>
          `)
        })
      }else{
        $('.collocation-product-detail-wrapper').empty();
          groupedProduct.forEach((item,i) => {
            const [d0, d1, d2] = item;// 数组里的三个对象
            const imgType = d0.type;
            $('.collocation-product-detail-wrapper').append(`
              <div class="swiper-slide swiper-slide-product" onclick="collocationDetail(${d0.id},${i})">
                <div class="img-add-all">
                  <img 
                    src="https://cdn.heychic.net/material/review/1-e4c21281e6e3796.jpg"
                    data-src="${imgType == 1 ? d0.url : d0.cover}"
                    class="collocation-cont-product-left lazy-img" 
                    alt="collocation-cont-product-left" />
                  <img src="https://cdn.heychic.net/material/model/detailAdd-52b2711cfebbda1.png" class="detailAdd" alt="detailAdd"/>
                </div>
                
                <div class="collocation-cont-right-img">
                  ${
                    d1 ? `<img 
                      src="https://cdn.heychic.net/material/review/1-e4c21281e6e3796.jpg"
                      data-src="${imgType == 1 ? d1.url : d1.cover}" 
                      class="collocation-cont-product-right lazy-img" 
                      alt="collocation-cont-product-right"/>` : ''
                  }
                  ${
                    d2 ? `<img 
                      src="https://cdn.heychic.net/material/review/1-e4c21281e6e3796.jpg"
                      data-src="${imgType == 1 ? d2.url : d2.cover}" 
                      class="collocation-cont-product-right lazy-img" 
                      alt="collocation-cont-product-right"/>` : ''
                  }
                </div>

              </div>
            `)
          })

          // 长宽一致
          const swiperWidth = $('.collocation-product-detail').width();
          $('.collocation-product-detail').height(swiperWidth);
      }


      // if (!isAppend) {
        botImgSwiper();
      // }
      if(isScene){
        // 懒加载
        const getInfo = document.querySelectorAll('.collocation-cont-right');
        getInfo.forEach(item => {
          initLazyImages(item);
        })
      }else{
        const getInfo = document.querySelector('.collocation-product-detail');
        initLazyImages(getInfo);
      }

      // 检测是否打开场景
      checkAndOpenSceneModal();
    }

    function initLazyImages(container) {
      const imgs = container.querySelectorAll('.lazy-img');

      const io = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;

            const img = entry.target;
            const src = img.dataset.src;

            if (src) {
              img.src = src;
              img.removeAttribute('data-src');
            }

            observer.unobserve(img);
          });
        },
        {
          root: null,
          rootMargin: '200px', // 快滑到前 200px 就开始加载
          threshold: 0.01
        }
      );

      imgs.forEach(img => io.observe(img));
    }

    // 带有分页
    getSceneDataPage(scenePage,sceneNum,search_tag);
    function getSceneDataPage(scenePage,sceneNum,search_tag, isAppend = false){
      if (isLoading) return;
      isLoading = true; // 设置加载状态为 true

      let product_handle = '';
      if(window.location.pathname.indexOf('products') > -1){
        product_handle = window.location.pathname.split('/')[ window.location.pathname.split('/').length - 1 ];
      }
      fetchRequest(`${heychic_api}/web/active/outfit/listByPage?search_product_handle=${product_handle}&page=${scenePage}&page_num=${sceneNum}&search_tag=${search_tag}`, "GET")
      .then((res) => {
          if(res.code == 200){
            const sceneData = res.data;
            // tag_list_get = sceneData.tag_list;//分类列表
            if (isAppend) {
              newDataScene = newDataScene.concat(sceneData.data);
            } else {
              newDataScene = sceneData.data;
            }

            const total = sceneData.total;//总数量
            const totalPage = Math.floor(total / (sceneData.per_page));//总页数
            totalNum = total;

            const loaded = newDataScene.length;

            hasMore = loaded < total;//是否还有更多
            if(sceneData.data && sceneData.data.length > 0){
              // 筛选tag数据
              // renderCategoryList(tag_list_get);
              
              listProduct(sceneData.data, totalPage, isAppend);
            }else{
              if(window.location.pathname.indexOf('products') > -1){
                $('.product-collocation').hide();
                $('.product-upsell-box').show();
              }else{
                $('.collocation-cont-right').empty();
                $('.collocation-cont-right').append(`
                    <div class="noRecords">
                        <img src="https://cdn.heychic.net/material/productInfo/noOrder-68ab5987e45a62f.png" class="noRecords-img" alt="noRecords-img" />
                        <div class="record-yet">No Data yet</div>
                    </div>
                `)

                $(".collocation-cont-left-title .total-nums").text(0);
              }
            }

            $('.collocation-cont-right-all').removeClass('has-halo-block-loader');
            isLoading = false;

          }
      })
      .catch((error) => {
          console.error("GET Error:", error);
          $('.collocation-cont-right-all').removeClass('has-halo-block-loader');
      }); 
    }

    let observer = null; // 全局

    function initLoadMoreObserver() {

      const items = document.querySelectorAll('.collocation-cont-right-item');

      if (!items.length) return;

      const lastItem = items[items.length - 1];

      if (observer) {
        observer.disconnect(); // ❗断开之前的
      }

      observer = new IntersectionObserver((entries) => {
        const entry = entries[0];

        if (!entry.isIntersecting) return;
        if (isLoading || !hasMore) return;

        scenePage++;
        getSceneDataPage(scenePage, sceneNum, search_tag, true);

      }, {
        root: null,
        rootMargin: '300px',
        threshold: 0
      });

      observer.observe(lastItem);
    }

    // 底部轮播
    function botImgSwiper() { 
      if(isScene){
        const sliderEl = document.querySelectorAll(".collocation-cont-right-item");

        sliderEl.forEach((sliderEl) => { 
          const sliderElTop = sliderEl.querySelector(".collocation-swiper-pic");
          // const sliderElBot = isScene ? sliderEl.querySelector(".collocation-swiper") : null;


          // const thumbsSwiperProduct = new Swiper(sliderElBot, {
          //   slidesPerView: 'auto',
          //   spaceBetween: 5,
          //   watchSlidesVisibility: true,
          //   centeredSlidesBounds: true,
          // });

          const mySwiper = new Swiper(sliderElTop, {
              slidesPerView: 1,
              allowTouchMove: window.location.pathname.includes("/products") ? false : true,      // 关键：禁止触摸滑动
              // thumbs: {
              //   swiper: isScene ? thumbsSwiperProduct : null
              // }
          })
        });
      }else{
        const sliderDetail = document.querySelector(".collocation-product-detail")
        const productSwiper = new Swiper(sliderDetail, {
          slidesPerView: 1,
          pagination: {
            el: '.swiper-pagination',
            type : 'fraction'
          },
        })
      }
    }

    function listProduct(tag_list,totalPage, isAppend = false) { 
      let product_ids = [];// 产品ID列表

      tag_list.forEach((r,t) => { 
        // renderProductList.push(r.data_list);
        renderProductList.push(r);
      })
      // newRenderProductList = [...new Map(renderProductList.flat().map(d => [d.id, d])).values()]; //去重(id)
      newRenderProductList = renderProductList;

      newRenderProductList.forEach((item) => { 
        product_lists.push(item.material_config.product_data);
      })

      let product_lists_new = [...new Map(product_lists.flat().map(y => [y.product_number, y])).values()]; //去重(product_number) 

      product_lists_new.forEach((item) => {
        product_ids.push(`gid://shopify/Product/${item.product_number}`);
      })

     

      fetch(`${graphql_api}/api/2024-01/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': graphql_token,
        },
        body: JSON.stringify({
          query,
          variables: {
            ids: product_ids,
            country: window.Shopify.country
          }
        })
      })
      .then(res => res.json())
      .then(res => {
        if(res.data){
          all_product_list = res.data.nodes.filter(item => item);// 过滤null

          if(window.location.pathname.indexOf('products') > -1){
            if(newDataScene.length > 0){
              rightCategoryProduct(tag_list);
            }else{
              $('.product-collocation').hide();
              $('.product-upsell-box').show();
            }
          } else {
            // 产品数据(单独页面)
            rightCategoryProduct(tag_list, isAppend);
            // 每次都调用，但只会初始化一次
            initLoadMoreObserver();
          }

          // renderPagination(totalNum, changePageNum); // 初始化分页
        }
      })
      .catch(error => console.error('Error:', error));
    }

    $('.scene-pagination').on('click', 'a', function (e) {
      e.preventDefault();

      const index = $(this).data('index');

      // 防止越界
      if (index < 0 || index >= totalNum) return;

      // 防止重复点击
      if (index === changePageNum) return;

      changePageNum = index;
      scenePage = index + 1;

      // renderPagination(totalNum, index);
      getSceneDataPage(scenePage, sceneNum, search_tag);
    });


    function renderPagination(totalPage, current) {
      const container = $('.scene-pagination');
      container.empty();

      const last = Math.ceil((totalPage/sceneNum) - 1);

      // ===== Prev =====
      if(current > 0){
        container.append(`
          <a class="page-prev" data-index="${current - 1}">
            Prev
          </a>
        `);
      }
      
      let start = Math.max(0, current - 1);
      let end = start + 2;

      if (end > last) {
        end = last;
        start = Math.max(0, end - 2);
      }

      for (let i = start; i <= end; i++) {
        container.append(`
          <a class="page-link ${i === current ? 'active' : ''}" data-index="${i}">
            ${i + 1}
          </a>
        `);
      }

      if (end < last - 1) {
        container.append(`<span class="ellipsis">...</span>`);
      }

      if (end < last) {
        container.append(`
          <a class="page-link ${current === last ? 'active' : ''}" data-index="${last}">
            ${last + 1}
          </a>
        `);
      }

      // ===== Next =====
      if(current < last){
        container.append(`
        <a class="page-next" data-index="${current + 1}">
          Next
        </a>
      `);
      }
    }

    // 产品详情
    window.collocationDetail = function(id,j) {
      if (hasMoved) {
        hasMoved = false; // 重置
        return;
      }

      if(window.location.pathname.indexOf('products') > -1 && window.innerWidth < 768){
        // 场景搭配详情弹框显示,隐藏底部加购
        $('.productView-stickyCart').hide();
      }

      $('.collocation-modal').empty();
      variant_id_list = [];

      let countryGet = window.Shopify.country;// 获取当前国家(US做特殊处理)

      // 筛选对应详情
      let filterProductObj;
      let productIdList; // 产品id列表
      filterProductObj = newRenderProductList.find(e => e.id == id) || sceneDetailObj;

      productIdList = filterProductObj.material_config.product_data.map((v,j) => {
        return `gid://shopify/Product/${v.product_number}`
      })

      $('.collocation-modal').show();

      let getProducts = all_product_list.filter(item =>
        productIdList.includes(item.id)
      );

      // 单独图片数据
      const orderListNew = filterProductObj.material_config.product_data;

      // 提取 product_number 数组
      const orderIds = orderListNew.map(item => item.product_number);

      // 重新排序
      const sortedProductsNew = orderIds
        .map(id => {
          return getProducts.find(p => p.id.includes(id));
        })
        .filter(Boolean); // 防止找不到

        $('.collocation-modal').append(
      `
      <div class="collocation-modal-content">
        <div class="h5-close-all">
          <img src="https://cdn.heychic.net/material/review/close-b399a262fb4c044.png" class="collocation-modal-close-h5" onclick="closeModalProduct()" alt="close">
          <div class="title-name-pc">${filterProductObj.title}</div>
        </div>
        
        <div class="collocation-modal-img-thumbs">
          <div class="collocation-modal-content-left swiper">
            <div class="swiper-wrapper">
              ${
                filterProductObj?.material_config?.show_data.map((t,index) => {
                  if(filterProductObj.type == 1){
                    return `<img src="${t.url}" alt="" class="swiper-slide collocation-modal-content-left-img">`
                  }else{
                    return `<video class="detail-video" src="${t.url}" autoplay loop muted playsinline webkit-playsinline></video>`
                  }
                  
                }).join('')
              }
            </div>
              <div class="swiper-pagination"></div>
          </div>
          <div class="swiper-thumbs-product-bot" style="display:none;">
            <div class="swiper-thumbs-product swiper">
              <div class="swiper-wrapper content-bot-bg">
                ${
                  filterProductObj?.material_config?.show_data.map((e,w) => {
                    return `<img src="${filterProductObj.type == 1 ? e.url : e.cover}" alt="" class="swiper-slide collocation-modal-content-bot-img">`
                  }).join('')
                }
              </div>
            </div>
          </div>
          
        </div>

        <div class="collocation-modal-content-right">
          <div class="modal-title ${window.innerWidth < 768 && !filterProductObj.content ? 'title-name-mobile' : ''}">
            <div class="title-name">${filterProductObj.title}  <img src="https://cdn.heychic.net/material/review/close-b399a262fb4c044.png" class="collocation-modal-close-pc" onclick="closeModalProduct()" alt="close"></div>
            <div class="title-desc">${filterProductObj.content}</div>
          </div>
          <div class="modal-product">
            ${
              sortedProductsNew.map((item,index) => {
                const variants = item?.variants?.nodes;
                if(variants?.length > 0){
                  const hideSize =
                    variants.length === 1 &&
                    variants[0]?.title === 'Default Title';

                    let firstTitleSelect = '';
                    let selectTitleList = item.variants.nodes.filter(e => e.availableForSale);
                    // 筛选第一个可用的size
                    if(selectTitleList.length > 0 && selectTitleList[0]?.title){ 
                      firstTitleSelect = selectTitleList[0]?.title;
                    }

                    return `
                      <div class="modal-product-item">
                        <a onclick="detailProductScene('${item.handle}')">
                          <img src="${filterProductObj?.material_config?.product_data[index].product_image}" alt="modal-product-item-img" class="modal-product-item-img">
                        </a>
                        <div class="modal-product-size-cont"> 
                          <div class="modal-product-item-name">${item.title}</div>
                          <div class="modal-product-item-price">
                          ${getCurrencySymbolAll(window.Shopify.currency.active)}${isInteger(item.priceRange?.maxVariantPrice.amount)}</div>
                          <div class="modal-product-size" style="display:${hideSize ? 'none' : 'flex'};" id="size-title-scene">
                            ${
                              item.variants.nodes.map(e => {
                                return `<div data-availableForSale="${e.availableForSale}"  data-product-id="${item.id}" data-variant-id="${e.id}" 
                                class="size-item-scene size-item ${e.availableForSale ? '' : 'sold-out'}" onclick="selectSize(this)">
                                ${convertAuToUsSize(e.title,2)}
                                </div>`
                              }).join('')
                            }
                          </div>
                        </div>
                      </div>`
                }
              }).join('')  
            }

            <div class="buy-button-all">
            ${
              variant_id_list.length <= 0 && sortedProductsNew.length > 0 ?`
              <a class="buy-button" href="#size-title-scene">Add to bag</a>
              `:sortedProductsNew.length == 0 ?`
              <a class="buy-button us-sold-out">Sold out</a>`
              :`
              <a class="buy-button" data-cart-sidebar onclick="goToCart()">Add to bag</a>
              `
            }
            </div>
          </div>
          
        </div>
      </div>
      `
    )
      // const sizeItemsAll = document.querySelectorAll('.size-item-scene');
      // // 检测所有变体是否都售罄
      // const allSoldOut = [...sizeItemsAll].every(
      //   item => item.getAttribute('data-availableForSale') === 'false'
      // );

      // if(allSoldOut){
      //   $('.buy-button-all .buy-button').addClass('sold-out-btn');
      // }else{
      //   $('.buy-button-all .buy-button').removeClass('sold-out-btn');
      // }

      // 修改 URL(spa)
      const urlChange = new URL(window.location.href);
      urlChange.searchParams.set('sceneId', id);
      window.history.pushState({}, '', urlChange);

      modalImgSwiper(j);
      // autoSelectAvailableVariants();
    }

    function queryDetail(id) {
      let product_ids = [];
      fetchRequest(`${heychic_api}/web/active/outfit/info?data_id=${id}`, "GET")
      .then((result) => {
          if(result.code == 200){
            sceneDetailObj = result.data;
            sceneDetailObj.material_config.product_data.forEach((item) => {
              product_ids.push(`gid://shopify/Product/${item.product_number}`);
            })
            
            fetch(`${graphql_api}/api/2024-01/graphql.json`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': graphql_token,
              },
              body: JSON.stringify({
                query,
                variables: {
                  ids: product_ids,
                  country: window.Shopify.country
                }
              })
            })
            .then(res => res.json())
            .then(res => {
              if(res.data){
                all_product_list = all_product_list.concat(res.data.nodes);
                window.collocationDetail(id);
              }
            })
            .catch(error => console.error('Error:', error));
          }
      })
      .catch((error) => {
          console.error("GET Error:", error);
      }); 
    }

    function checkAndOpenSceneModal() {
        const sceneId = getUrlParameter('sceneId');
        if (sceneId) {
            const targetId = Number(sceneId);
            // 验证 ID 是否存在于已加载的数据中
            const exists = newRenderProductList.some(item => item.id === targetId);
            
            if (exists) {
                if (all_product_list.length > 0) {
                  // 使用 setTimeout 确保 DOM 完全渲染
                  setTimeout(() => {
                      window.collocationDetail(targetId);
                  }, 100);
                }
            }else{
              queryDetail(targetId);
            }
        }
    }
    function modalImgSwiper(j) { 
      const sliderEl = document.querySelectorAll(".collocation-modal-img-thumbs");
      sliderEl.forEach((sliderEl) => { 
        const sliderElTop = sliderEl.querySelector(".collocation-modal-content-left");
       // const sliderElBot = sliderEl.querySelector(".swiper-thumbs-product");

        // const thumbsSwiper = new Swiper(sliderElBot, {
        //   slidesPerView: 5,
        //   spaceBetween: 5,
        //   watchSlidesProgress: true,
        //   centeredSlidesBounds: true,
        // });

        const mySwiper = new Swiper(sliderElTop, {
          slidesPerView: 1,
          initialSlide: 0,
          pagination: {
            el: sliderElTop.querySelector(".swiper-pagination"),
            type: 'progressbar',
          },
        //   thumbs: {
        //   swiper: thumbsSwiper
        // }
        });
      })
    } 

    // 抽取变体逻辑
    function upsertVariant({ variantGid, productId,availableForSale }) {
      const variantId = variantGid.split('/').pop();

      const existingIndex = variant_id_list.findIndex(
        item => item.productIdentifier === productId
      );

      const data = {
        id: variantId,
        quantity: 1,
        productIdentifier: productId,
        availableForSale: availableForSale,
      };

      if (existingIndex > -1) {
        variant_id_list[existingIndex] = data;
      } else {
        variant_id_list.push(data);
      }
    }

    // 自动选择有库存的变体
    function autoSelectAvailableVariants() {
      variant_id_list = [];

      // 为每个产品项选择第一个有库存的变体
      $('.modal-product-item').each(function() {
        const productItem = $(this);
        const firstAvailableSize = productItem.find('.size-item[data-availableForSale="true"]').first();
        
        if (!firstAvailableSize.length) return;

        upsertVariant({
          variantGid: firstAvailableSize.attr('data-variant-id'),
          productId: firstAvailableSize.attr('data-product-id'),
          availableForSale: firstAvailableSize.attr('data-availableForSale')
        });
      });
    }

    window.detailProductScene = function(handle) {
      closeModalProduct();
      window.location.href = `/products/${handle}`;
    }

    window.selectSize = function(e) {
      
      const isAlreadySelected = $(e).hasClass('size-item-active');

      if(isAlreadySelected){
        $(e).removeClass('size-item-active');
        // 从 variant_id_list 中移除该产品的变体
        const variantGid = $(e).attr('data-variant-id');
        variant_id_list = variant_id_list.filter(item => !variantGid.includes(item.id));
      }else{
        // 更新界面显示
        $(e).parents('.modal-product-size-select').find('.size-text').text($(e).text());
          upsertVariant({
          variantGid: $(e).attr('data-variant-id'),
          productId: $(e).attr('data-product-id'),
          availableForSale: $(e).attr('data-availableForSale')
        });

        // 更改选中size样式
        $(e).addClass('size-item-active').siblings().removeClass('size-item-active');
      }

      $('.buy-button-all').empty();
      if(variant_id_list.length <= 0){
        $('.buy-button-all').append(`
          <a class="buy-button" href="#size-title-scene">Add to bag</a>
        `)
      }else{
        $('.buy-button-all').append(`
            <a class="buy-button" onclick="goToCart()">Add to bag</a>
          `)
        }
      }

    window.showProductSize = function(e) {
      $(e).find('.size-list').toggle();
      $(e).find('.botTriModal').toggleClass('botTriModalActive');
    }

    window.closeModalProduct = function() {
      $('.collocation-modal').hide();
      // 清除 URL 参数
      const urlDel = new URL(window.location);
      urlDel.searchParams.delete('sceneId');
      window.history.replaceState({}, '', urlDel);
      if(window.location.pathname.indexOf('products') > -1 && window.innerWidth < 768){
        // 场景搭配详情弹框显示,隐藏底部加购
        $('.productView-stickyCart').show();
      }
    }

    window.goToCart = function(i) {
      // const $currentProductItem = $('.modal-product-item').eq(i);// 当前商品
      // const productId = $currentProductItem.find('.size-item').first().attr('data-product-id');// 商品id
      // const variantIdList = variant_id_list.find(item => item.productIdentifier === productId);// 商品变体id并且可用
      closeModalProduct();
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items:variant_id_list
        })
      })
      .then(res => res.json())
      .then(data => {
        if(data.status === 422){
          showToastTips(data.message, 'error')
        }else{
          updateCartItemsEnter();
          var cartNumberProduct = parseInt($('#cart-number-pc').text());
          $('#cart-number-pc').text(cartNumberProduct + variant_id_list.length);

          var cartNumberH5 = parseInt($('#cart-number').text());
          $('#cart-number').text(cartNumberH5 + variant_id_list.length);
        }
        
      });
    }
  })